import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';

// Police auto-hébergée : aucun appel à un service externe, la CSP reste stricte.
import '@fontsource/noto-sans/400.css';
import '@fontsource/noto-sans/500.css';
import '@fontsource/noto-sans/600.css';
import '@fontsource/noto-sans/700.css';

import './i18n';
import './index.css';
import App from './App';
import { CouleursMarque } from './components/layout/CouleursMarque';
import { appliquerCouleursMemorisees } from './lib/couleurs-marque';
import { queryClient } from './lib/queryClient';

// Couleurs de la marque retenues au chargement précédent, posées avant le
// premier rendu : pas d'éclair des couleurs par défaut en attendant l'API.
appliquerCouleursMemorisees();

const racine = document.getElementById('root');
if (!racine) throw new Error('Élément #root introuvable dans index.html.');

createRoot(racine).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <CouleursMarque />
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
